import React from 'react';
import { galleryUrlLabel } from '../utils/galleryHost';

export default function GalleryNotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background p-6 text-center">
      <h1 className="text-2xl font-serif text-secondary mb-2">Gallery not found</h1>
      <p className="text-secondary-70 text-sm max-w-md leading-relaxed">
        This link may be incorrect or the gallery is no longer available. Check your invitation for the
        correct <span className="whitespace-nowrap">{galleryUrlLabel('…')}</span> link.
      </p>
    </div>
  );
}
